<template>
  <div class="example-simple">
    <div class="upload">
      <template v-if="this.files && this.files.length !== 0" >
        <div class="row" style="margin: 20px 0">
          <template v-for="(file, index) in files">
            <div class="row" v-if="index % 4 === 0"></div>
            <div  class="col-xs-3" :key="index">
              <div class="hpanel">
                <div class="panel-heading" style="height: 40px">
                  <div class="pull-right">
                    <button type="button" class="btn btn-danger btn-xs btn-outline" @click="removeFile(file)"><i class="fa fa-remove"></i> Remove</button>
                  </div>
                </div>
                <a :href="$apiUrl + file.filename" target="_blank">

                  <template v-if="isPicture(file.filename)">
                    <div class="panel-body file-body" style="padding: 10px">
                      <div style="height: 150px; max-width: 100%">
                        <img :src="$apiUrl + file.filename" width="100%" style="max-height: 150px" :title="file.filename.match('.*\/(.*)')[1]">
                      </div>
                    </div>
                  </template>
                  <template v-else>
                    <div class="panel-body file-body" style="padding: 57px">
                      <template v-if="/(pdf)$/ig.test(file.filename)">
                        <i class="fa fa-file-pdf-o text-danger"></i>
                      </template>
                      <template v-else-if="/(doc|docx)$/ig.test(file.filename)">
                        <i class="fa fa-file-word-o text-info"></i>
                      </template>
                      <template v-else-if="/(xlsx|xlsm|xlsb|xls)$/ig.test(file.filename)">
                        <i class="fa fa-file-excel-o text-success"></i>
                      </template>
                      <template v-else>
                        <i class="fa fa-file-o text-dark"></i>
                      </template>

                    </div>
                  </template>
                </a>
                <div class="panel-footer">
                  <h5 v-if="file.file_type"> {{file.file_type}}</h5>
                  <a :href="$apiUrl + file.filename" target="_blank" class="text-info">Download</a>
                </div>

              </div>
            </div>

          </template>
        </div>
      </template>
      <div v-if="uploadFiles && uploadFiles.length !== 0" class="row" style="margin-left: -40px; max-height: 350px; overflow: auto;">
        <ul>
          <li v-for="(uploadFile, key) in uploadFiles" :key="key" :id="'attachedDoc-'+key" class="text-left"
              style="    display: inline-block; margin-top: 20px;" v-if="type !== 'biblio_doc' || (type === 'biblio_doc' && typeof uploadFile.link == 'undefined')" >
            <div class="col-sm-8 m-t-xs"> {{uploadFile.name}} - {{uploadFile.size}} kb</div>
            <div class="col-sm-4 m-t-xs text-right">
              <button type="button" style="margin-left: 15px" class="btn btn-danger btn-xs btn-outline"
                      @click="removeUploadFile(uploadFile)"><i class="text-danger fa fa-remove"></i> Remove
              </button>
            </div>

            <div class="col-sm-12 m-t-xs" v-if="type === 'company_doc'">
              <v-select2 :options="company_docs" label="name" :name="'SelectAttachedDoc-'+key"
                         v-model="uploadFile.content_type" :searchable="false"
                         :placeholder="'Please Choose Document Type...'" required
                         :dropdownParent="'attachedDoc-'+key"></v-select2>
            </div>
            <div class="col-sm-12 m-t-xs" v-if="type === 'biblio_doc'">

              <div class="form-group">
                <label class="col-sm-12 control-label text-left m-b-xs">Title </label>
                <div class="col-sm-12 m-b-xs">
                  <input type="text" v-model="uploadFile.title" class="form-control" maxlength="500"
                         placeholder="Document title" required>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label text-left m-b-xs">Authors </label>
                <div class="col-sm-12 m-b-xs">
                  <input type="text" v-model="uploadFile.authors" class="form-control" maxlength="100"
                         placeholder="Authors (Last Name, First Name) separated by ;" required>
                </div>
              </div>
              <div class="form-group">
                <label class="col-sm-12 control-label text-left m-b-xs">Source </label>
                <div class="col-sm-12 m-b-xs">
                  <input type="text" v-model="uploadFile.source" class="form-control" maxlength="100"
                         placeholder="Source (Internal, Journal, ….)" required>
                </div>
              </div>

              <div class="form-group">
                <label class="col-sm-12 control-label text-left m-b-xs">Abstract </label>
                <div class="col-sm-12 m-b-xs">
                <textarea v-model="uploadFile.description" class="form-control" maxlength="5000"
                          placeholder="5000 characters max to summarise attached document"
                          rows="3" cols="3" required></textarea>
                  <span class="help-block m-b-none text-right" v-if="uploadFile.description">{{uploadFile.description.length}} Characters</span>
                </div>
              </div>
              <hr class="col-xs-11 m-b-xs" style=" border-top: solid 3px #3498db; ">
            </div>
          </li>
        </ul>
      </div>

      <div class="example-btn">
        <label class="btn btn-primary btn-outline btn-sm file-uploads file-uploads-html5"><i class="fa fa-plus"></i>
          Select files
          <input type="file" name="files" accept="image/*,.doc,.docx,.pdf,.xlsx,.xlsm,.xlsb,.xls" multiple="multiple" style="display: none" @change="onChange($event)"></label>
      </div>
    </div>
  </div>
</template>
<style>
  .example-simple label.btn {
    margin-bottom: 0;
    margin-right: 1rem;
  }
</style>

<script>
import vSelect2 from '../../components/utils/select2'

export default {
  name: 'UploadFile',
  props: ['files', 'uploadFiles', 'type', 'removeFile'],
  components: {vSelect2},
  data () {
    return {
      company_docs: [
        {id: 1, code: 'cp_desc', name: 'Company Description'},
        {id: 2, code: 'pr_inf', name: 'Product Info'},
        {id: 3, code: 'patent', name: 'Patent'},
        {id: 4, code: 'other', name: 'Other'} ]
    }
  },
  methods: {
    onChange: function (event) {
      for (let i = 0; i < event.target.files.length; i++) {
        this.uploadFiles.push(event.target.files[i])
      }
    },
    isPicture: function (value) {
      return /(jpg|jpeg|png)$/ig.test(value)
    },
    removeUploadFile: function (uploadFile) {
      let index = this.uploadFiles.indexOf(uploadFile)

      this.uploadFiles.splice(index, 1)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/question/UploadFile.vue